import { IDonorPreselectNote, ILkdpiInfo, IPreselectDonorInfo, IRecipient, ISingleEpletMmRisk } from '@nkr/models/index';
import { PotentialDonorCategory } from '@nkr/enums/potential-donor-category';
import { DonorPreselectReviewStatus } from '@nkr/enums/donor-preselect-review-status';

export interface IRowData {
    recipient: IRecipient,
    donor: IPreselectDonorInfo,

    /**
     * Was compatibilityResult: ICompatibilityResult. The grid read four of its members plus its
     * donor, so those are flat here and the per-row recipient copy is gone - the page-level
     * recipient serves LkdpiInfo, the only thing that used it. The required pre-selects page
     * carries the identical shape; both share list2, grid and the confirm dialogs.
     */
    failedAvoids: string[],
    hlaPointsA: number,
    hlaPointsB: number,
    hlaPointsDr: number,
    totalHlaPoints: number,
    isHardBlocked: boolean,

    singleEpletMmRisk: ISingleEpletMmRisk,
    lkdpiInfo: ILkdpiInfo,
    categories: PotentialDonorCategory[],
    isPairedDonor: boolean,
    isFirst: boolean,
    reviewStatus: DonorPreselectReviewStatus,
    donorNote: IDonorPreselectNote,
    matchNote: IDonorPreselectNote,
    bmtMm: number,
    matchOfferId: number,
    isSelected: boolean,
    responseDeadLineDate: string
    isReviewRequested: boolean,
    reviewRequestedDate: string
}
